.dz{padding:0.5rem;}